import { useOutletContext } from 'react-router-dom'

import type { OrganizationDetail } from '@/definitions/organization'

export interface OrgRouteContext {
  org: OrganizationDetail
}

/**
 * The organization the current route is about.
 *
 * `OrgDetailPage` has already fetched it and refuses to render its tabs without
 * it, so a tab receives it non-nullable and needs neither its own request nor a
 * guard for a state its parent has ruled out.
 *
 * Only callable from something rendered inside that route — this rides
 * react-router's outlet rather than a provider, so there is no wrapping it around
 * an arbitrary subtree. The organization itself stays in the TanStack cache, where
 * invalidating it still reaches every reader.
 */
export const useRouteOrg = (): OrganizationDetail =>
  useOutletContext<OrgRouteContext>().org
